import $ from 'jquery';
import Alpine from 'alpinejs';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min.js';
import initRoundup from './roundup';
import initMenu from './menu';
import initLanguageSelect from './language-select';
import initManualAddressToggle from './address-fields';
import initDirectDebit from './direct-debit';
import registerPostcodeLookup from './postcode-lookup';

declare global {
    interface Window {
        $: typeof $;
        jQuery: typeof $;
        Alpine: typeof Alpine;
    }
}

window.$ = $;
window.jQuery = $;
window.Alpine = Alpine;

// Register the Loqate postcode-lookup component before Alpine walks the DOM, so
// it always exists on pages that use x-data="postcodeLookup".
registerPostcodeLookup(Alpine);
Alpine.start();

$(document).ready(function () {
    initRoundup();
    initMenu();
    initLanguageSelect();
    initManualAddressToggle();
    initDirectDebit();
});
